module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-14.2c6575d5.png";